module.exports = __webpack_public_path__ + "static/media/code-icon@2x.c03b08ca.png";